module.exports = __webpack_public_path__ + "static/media/nb_tidepool_closeup_bg.baf28f8e.jpg";